import React from "react";

// HSC brand logo (white wordmark + "HIDDEN SPORTS CLUB" baked in, transparent bg).
// Served from /public/hsc-logo.png. Sizes are heights (px); width scales proportionally.
export function HscLogo({ size = "text-2xl", className = "", height }) {
  const heights = { "text-lg": 34, "text-xl": 42, "text-2xl": 50, "text-4xl": 76 };
  const h = height || heights[size] || 42;
  return (
    <div className={`flex ${className}`}>
      <img src="/hsc-logo.png" alt="HSC — Hidden Sports Club" style={{ height: h }}
        className="w-auto object-contain" draggable={false} />
    </div>
  );
}
